import React from 'react'
import { Box, Button, Grid, Typography} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import { useNavigate } from 'react-router-dom';
import ActionButton from '../../../components/ActionButtons'
function CustomColumnMenu(props) {
  return (
    
    <GridColumnMenu
      {...props}
      slots={{
     // Hide `columnMenuColumnsItem`
      columnMenuColumnsItem: null,
      columnMenuSortItem: null,
      }}
    />
    
);
}
const columns = [
  { field: 'Customer_No', headerName: ' Cus Code', editable: false, sortable: false, minWidth: 100 },
  { field: 'Customer_Name', headerName: 'Customer Name', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Address', headerName: 'Address', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Street_Name', headerName: 'Street Name', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Post_Code', headerName: 'Post Code', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Mob_No', headerName: 'Mobile No', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'Email', headerName: 'Email', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 180, renderCell: (params) => {
    return (
    <ActionButton />
    );
    }}
]
const rows = [ 
    {Customer_No:'JB02033',Customer_Name:'James Anderson',Address:'18 Sprint Street Paddington London ',Street_Name:'Sprint Street' ,Post_Code:'W23RA',Email :'jamesjj@gmail.com',Mob_No:'334-707-9993'},
    {Customer_No:'AC5678',Customer_Name:'Antony Wilson',Address:'38b Denmead Road Bournemouth',Street_Name:'Denmead Road',Post_Code:' BH6 5QH',Email :'antonyw@gamil.com',Mob_No:'407-603-5073'},
    {Customer_No:'BG1138',Customer_Name:'Emma Moore',Address:'Royal Oak House Greenfield Rd, Greenfield Holywell',Street_Name:'Royal Oak House ',Post_Code:' CH8 7QB',Email :'emmamoore@gamil.com',Mob_No:'731-487-0128'},
    {Customer_No:'JK1641',Customer_Name:'Andrew Moffatt',Address:'40 Longwall Road Pontefract,UK',Street_Name:'Longwall Road',Post_Code:' WF8 4SW',Email :'andrewmtt@gmail.com',Mob_No:'334-741-0808'},
    {Customer_No:'DO2134',Customer_Name:'Jade Mccheyne',Address:'70 Knowles Street Radcliffe,Manchester ',Street_Name:'Knowles Street',Post_Code:'M26 4DT',Email :'mccheynejade@gmail.com',Mob_No:'615-829-2259'},
    {Customer_No:'OI2015',Customer_Name:'Bradley O connell',Address:'11 Manor Crescent Carmarthen,UK',Street_Name:'Manor Crescent',Post_Code:' SA31 3RJ', Email :'oconnel12@gmail.com',Mob_No:'404-805-9531'},
    {Customer_No:'FT3642',Customer_Name:'Gareth Walker',Address:'6 Florence Way Peterborough,UK',Street_Name:'Florence Way',Post_Code:' PE6 8PG',Email :'garethwalker@gmail.com',Mob_No:'615-829-2259'},
    {Customer_No:'PB7213',Customer_Name:'Craig Rice',Address:'29 Queens Drive Stranraer UK',Street_Name:' Queens Drive',Post_Code:'DG9 0DH',Email :'craigr12@gmail.com',Mob_No:'832-782-3213'},
    {Customer_No:'CR1001',Customer_Name:'Paul McCann',Address:'23 Burns Place Shotts,UK',Street_Name:'Burns Place',Post_Code:'ML7 4LQ',Email :'paulcann@gmail.com',Mob_No:'678-880-7131'},
    {Customer_No:'LM1024',Customer_Name:'Joshua Bullen',Address:'28 Springfield Close Pevensey ,UK',Street_Name:'Springfield Close',Post_Code:' BN24 5JG',Email :'joshuabullen@gmail.com',Mob_No:'850-585-7045'},

  ];
function Customer() {
const navigate = useNavigate()
return (
  
  <Box mt={2}>
    <Grid container spacing={1}>
    <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>CUSTOMER DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end'>
           <Button sx={buttonStyle.root} onClick={() => navigate('/Customer_Add_Edit')}><AddIcon />Add Customer</Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} mt={1}>
        <Box sx={dataGridStyle.root}>
          <DataGrid
            columnHeaderHeight={42}
            rowHeight={40}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.Customer_No}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
      </Grid>
    </Grid>
  </Box>
)
}

export default Customer